import { render, staticRenderFns } from "./QuestionButtons.vue?vue&type=template&id=65635a8f"
import script from "./QuestionButtons.vue?vue&type=script&lang=js"
export * from "./QuestionButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports